import React from 'react';

const About = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>Welcome to Western MA Kids Activities. We provide information about various activities for kids in Western Massachusetts.</p>
    </div>
  );
};

export default About;